/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CtmsItemRespVo } from './CtmsItemRespVo';
import {
    CtmsItemRespVoFromJSON,
    CtmsItemRespVoFromJSONTyped,
    CtmsItemRespVoToJSON,
    CtmsItemRespVoToJSONTyped,
} from './CtmsItemRespVo';

/**
 * 
 * @export
 * @interface ResponseCtmsItemRespVo
 */
export interface ResponseCtmsItemRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseCtmsItemRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseCtmsItemRespVo
     */
    message?: string;
    /**
     * 
     * @type {CtmsItemRespVo}
     * @memberof ResponseCtmsItemRespVo
     */
    data?: CtmsItemRespVo;
}

/**
 * Check if a given object implements the ResponseCtmsItemRespVo interface.
 */
export function instanceOfResponseCtmsItemRespVo(value: object): value is ResponseCtmsItemRespVo {
    return true;
}

export function ResponseCtmsItemRespVoFromJSON(json: any): ResponseCtmsItemRespVo {
    return ResponseCtmsItemRespVoFromJSONTyped(json, false);
}

export function ResponseCtmsItemRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseCtmsItemRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : CtmsItemRespVoFromJSON(json['data']),
    };
}

export function ResponseCtmsItemRespVoToJSON(json: any): ResponseCtmsItemRespVo {
    return ResponseCtmsItemRespVoToJSONTyped(json, false);
}

export function ResponseCtmsItemRespVoToJSONTyped(value?: ResponseCtmsItemRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': CtmsItemRespVoToJSON(value['data']),
    };
}

